<!-- 
  评论组件
  props: 
    refId: 传入的Id
    refType: 模块名，如 communicate
 -->

<template>
  <div class="report">
    <comment-box :isOpen="false" @reportContent="getContent"></comment-box>
    <ul class="com-list">
      <li class="com-item" v-for="(item, index) in reportList">
        <div class="title">
          <span class="name">{{item.userName}}</span>
          <a href="javascript:;" class="option del" @click="handleDel(item.id)" v-if="item.userId === currentUserId">删除</a>
          <a href="javascript:;" class="option rep" @click="report(index)">回复</a>
        </div>
        <div class="avatar">
          <img width="36" height="36" :src="item.userAvatar" :alt="item.userName">
        </div>
        <div class="post-time">{{item.addTime}}</div>
        <div class="desc">
          <span v-show="item.refUserName" class="at">@{{item.refUserName}}</span>
          <p class="text" v-for="p in paragraph(item.content)" :key="p">{{p}}</p>
        </div>
        <comment-box
          v-if="currentIndex === index"
          :defUserId="item.userId"
          :isOpen="true"
          @reportContent="getContent">
        </comment-box>
      </li>
    </ul>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message, MessageBox } from 'element-ui'
import commentBox from 'components/common/comment-box'

export default {
  created () {
    this.getReports()
    this.currentUserId = 1
  },
  props: {
    refId: {
      type: Number,
      required: true
    },
    refCommentId: {
      type: Number
    },
    refType: {
      type: String,
      default: 'communicate'
    },
    commentCount: {
      type: Number
    }
  },
  data () {
    return {
      reportList: [],
      // 当前展开的评论窗口
      currentIndex: '',
      currentUserId: 0 // 当前登录的用户Id
    }
  },
  methods: {
    // 获取评论和点赞
    getReports () {
      const url = '/commentApi/getLikeAndCommentInfo.html'
      const params = {
        refId: this.refId,
        refType: this.refType
      }
      if (this.refType === 'workOrder') {
        // 工单动态获取评论点赞，传的是工单动态的id
        params.refId = this.refCommentId
      }
      api.post(url, params, (data) => {
        this.reportList = data.commentArray
        this.$emit('update:commentCount', this.reportList.length)
      })
    },
    // 删除事件
    handleDel (id) {
      MessageBox.confirm('确定删除该回复吗?', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.del(id)
      }).catch(() => {})
    },
    // 删除
    del (id) {
      const url = '/commentApi/delete.html'
      const params = {
        commentId: id
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功！'
        })
        this.getReports()
      })
    },
    // 回复
    report (userId) {
      this.currentIndex = userId
    },
    // 获取评论内容
    getContent (content, refUserId, cb) {
      // TODOS: refUserId 改为数组，服务端还没改 20170414
      if (content) {
        const url = '/commentApi/save.html'
        const params = {
          refId: this.refId,
          refType: this.refType,
          content: content,
          refCommentId: this.refCommentId,
          rootId: '',
          refUserId: refUserId
        }
        api.post(url, params, (data) => {
          this.currentIndex = ''
          cb()
          this.getReports()
        })
      } else {
        Message({
          type: 'error',
          message: '请输入回复内容！'
        })
      }
    },
    // 将换行内容分割为数组
    paragraph (str) {
      if (str) {
        return str.split('\n')
      } else {
        return []
      }
    }
  },
  components: {
    commentBox
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .report {
    position: relative;
    padding: 15px;
    box-shadow: 0 1px 2px 0 #cdd9eb inset;
    .com-list {
      border-top: 1px dashed #dee8f5;
      .com-item {
        position: relative;
        margin: 15px 0 0 50px;
        font-size: 0;
        border-bottom: 1px solid #dee8f5;
        &:hover {
          .title {
            .option {
              visibility: visible;
            }
          }
        }
        .title {
          text-align: right;
          line-height: 1;
          padding: 2px 0;
          overflow: hidden;
          vertical-align: top;
          .name {
            font-size: 14px;
            float: left;
            color: #4e617c;
          }
          .option {
            font-size: 13px;
            color: @light-blue;
            padding-right: 12px;
            border-right: 1px solid @light-blue;
            margin-right: 12px;
            visibility: hidden;
            &:last-child {
              margin-right: 0;
              border-right-width: 0;
              padding-right: 0;
            }
            &:hover {
              color: @bg-red;
            }
          }
        }
        .avatar {
          position: absolute;
          left: -46px;
          top: 0;
          width: 36px;
          height: 36px;
        }
        .post-time {
          line-height: 1;
          font-size: 13px;
          color: @light-gray;
          margin-top: 5px;
        }
        .desc {
          font-size: 13px;
          line-height: 1.6;
          margin-top: 12px;
          padding-bottom: 12px;
          word-break: break-all;
          .at {
            color: @primary;
            margin-right: 4px;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// report.vue?21252301